exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.ue-edit[data-v-7a7d65ad] {\n  width: 100%;\n  line-height: normal;\n}\n#edui_fixedlayer[data-v-7a7d65ad] {\n  z-index: 3000 !important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7a7d65ad","scoped":true,"hasInlineConfig":false}!./~/less-loader/dist/cjs.js?{"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ueEditor.vue
// module id = 1147
// module chunks = 7